import { jsxs, jsx } from 'react/jsx-runtime';

const TrustWalletTransparentIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx("mask", { id: "mask0_3705_16119", maskUnits: "userSpaceOnUse", x: "6", y: "5", width: "28", height: "30", children: /* @__PURE__ */ jsx("path", { d: "M6.66699 5H33.3337V34.6187H6.66699V5Z", fill: "white" }) }),
    /* @__PURE__ */ jsxs("g", { mask: "url(#mask0_3705_16119)", children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.91309 9.2784L20.0768 5V34.6187C10.6741 30.6693 6.91309 23.0999 6.91309 18.8223V9.2784Z",
          fill: "#0400F5"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M33.2389 9.2784L20.0752 5V34.6187C29.4779 30.6693 33.2389 23.0999 33.2389 18.8223V9.2784Z",
          fill: "url(#paint0_linear_3705_16119)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M33.2389 9.2784L20.0752 5V34.6187C29.4779 30.6693 33.2389 23.0999 33.2389 18.8223V9.2784Z",
          fill: "url(#paint1_linear_3705_16119)"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_3705_16119",
          x1: "19.5197",
          y1: "38.3416",
          x2: "30.2945",
          y2: "-0.629981",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: "0.26", stopColor: "#48FF91" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.66", stopColor: "#0094FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.8", stopColor: "#0038FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.89", stopColor: "#0500FF" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint1_linear_3705_16119",
          x1: "29.4966",
          y1: "3.28804",
          x2: "19.5534",
          y2: "34.5764",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { offset: "0.02", stopColor: "#0000FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.08", stopColor: "#0094FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.16", stopColor: "#48FF91" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.42", stopColor: "#0094FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.68", stopColor: "#0038FF" }),
            /* @__PURE__ */ jsx("stop", { offset: "0.9", stopColor: "#0500FF" })
          ]
        }
      )
    ] })
  ] });
};
const TrustWalletIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "60", height: "60", viewBox: "0 0 60 60", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx("rect", { width: "60", height: "60", rx: "16", fill: "#242426" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.2197 15.7781L29.9971 10V50C17.2988 44.6662 12.2197 34.444 12.2197 28.6672V15.7781Z",
        fill: "#48FF91"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M47.7764 15.7781L29.999 10V50C42.6973 44.6662 47.7764 34.444 47.7764 28.6672V15.7781Z",
        fill: "url(#paint0_linear_5881_50281)"
      }
    ),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint0_linear_5881_50281",
        x1: "29.2483",
        y1: "55.0274",
        x2: "43.7988",
        y2: "2.39678",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { offset: "0.26", stopColor: "#48FF91" }),
          /* @__PURE__ */ jsx("stop", { offset: "0.66", stopColor: "#0094FF" }),
          /* @__PURE__ */ jsx("stop", { offset: "0.8", stopColor: "#0038FF" }),
          /* @__PURE__ */ jsx("stop", { offset: "0.89", stopColor: "#0500FF" })
        ]
      }
    ) })
  ] });
};

const trustWalletConfig = {
  name: "Trust Wallet",
  logos: {
    default: /* @__PURE__ */ jsx(TrustWalletIcon, {}),
    transparent: /* @__PURE__ */ jsx(TrustWalletTransparentIcon, {})
  },
  downloadUrls: {
    default: "https://trustwallet.com/"
  },
  spinnerColor: "#1098FC"
};

export { trustWalletConfig as t };
